/** Document access level label with icon (private / specific users / public) */

import { Globe, Lock, Users, type LucideIcon } from 'lucide-react'
import type { AccessLevel } from '@agentwiki/shared'
import { useT, type TranslationKey } from '../../i18n'

export const ACCESS_LEVEL_LABEL_KEYS: Record<AccessLevel, TranslationKey> = {
  private: 'documents.access.private',
  specific: 'documents.access.specific',
  public: 'documents.access.public',
}

const ACCESS_LEVEL_ICONS: Record<AccessLevel, LucideIcon> = { private: Lock, specific: Users, public: Globe }

export function AccessLevelBadge({ level }: { level: AccessLevel }) {
  const t = useT()
  const Icon = ACCESS_LEVEL_ICONS[level] ?? Lock
  return (
    <span className="inline-flex items-center gap-1">
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {t(ACCESS_LEVEL_LABEL_KEYS[level] ?? 'documents.access.private')}
    </span>
  )
}
